
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/analytics/engagement",
      function () {
        return require("private-next-pages/analytics/engagement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/analytics/engagement"])
      });
    }
  